<template>
  <div class="rp-card">
    <div class="rp-card-image-wrapper" :style="{ backgroundImage: `url(${group.image})` }">
      <div v-if="group.lowAvailability" class="rp-badge rp-badge-warning rp-badge-absolute">
        Ostatnie miejsca
      </div>
      
      <div v-if="group.noAvailability" class="rp-badge rp-badge-danger rp-badge-absolute">
        SOLD OUT
      </div>

      <div v-if="group.available && !group.lowAvailability" class="rp-badge rp-badge-success rp-badge-absolute">
        Wolne miejsca
        </div>
    </div>
    
    <div class="rp-card-content">
      <h3 class="rp-card-title">{{ group.name }}</h3>
    </div>
      
    <div class="rp-card-details">
      <div class="rp-card-detail-row">
        <svg class="rp-card-detail-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 10.8333C11.3807 10.8333 12.5 9.71404 12.5 8.33333C12.5 6.95262 11.3807 5.83333 10 5.83333C8.61929 5.83333 7.5 6.95262 7.5 8.33333C7.5 9.71404 8.61929 10.8333 10 10.8333Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10 17.5C13.3333 14.1667 16.6667 11.0152 16.6667 8.33333C16.6667 4.65143 13.6819 1.66667 10 1.66667C6.31811 1.66667 3.33334 4.65143 3.33334 8.33333C3.33334 11.0152 6.66668 14.1667 10 17.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        <span class="rp-card-detail-text">{{ group.location?.name }}</span>
        </div>
        
      <div class="rp-card-detail-row">
        <svg class="rp-card-detail-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.66667 1.66667V4.16667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M13.3333 1.66667V4.16667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2.91667 7.57583H17.0833" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M17.5 7.08333V14.1667C17.5 16.6667 16.25 18.3333 13.3333 18.3333H6.66667C3.75 18.3333 2.5 16.6667 2.5 14.1667V7.08333C2.5 4.58333 3.75 2.91667 6.66667 2.91667H13.3333C16.25 2.91667 17.5 4.58333 17.5 7.08333Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        <span class="rp-card-detail-text">
          {{ group.startFormatted }}    
          </span>
        </div>
        
      <div class="rp-card-detail-row">
        <svg class="rp-card-detail-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.83334 15V11.6667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10 15V8.33333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14.1667 15V5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        <span class="rp-card-detail-text">{{ group.level?.title }}</span>
        </div>
        
      <div class="rp-card-detail-row">
        <svg class="rp-card-detail-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.0001 9.99999C12.3013 9.99999 14.1667 8.13451 14.1667 5.83332C14.1667 3.53214 12.3013 1.66666 10.0001 1.66666C7.69889 1.66666 5.83341 3.53214 5.83341 5.83332C5.83341 8.13451 7.69889 9.99999 10.0001 9.99999Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M17.1583 18.3333C17.1583 15.1083 13.95 12.5 10 12.5C6.04996 12.5 2.84164 15.1083 2.84164 18.3333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        <span class="rp-card-detail-text">
          <span v-for="(instructor, i) in group.instructors" :key="i">
            {{ instructor.fullName }}<span v-if="i < group.instructors.length - 1">, </span>
          </span>
        </span>
      </div>
    </div>
      
    <div class="rp-card-footer">
      <span class="rp-card-price">{{ group.price }} zł</span>
        
        <a v-if="group.reservationLink" 
           :href="group.reservationLink"
           target="_blank"
         class="rp-btn rp-btn-primary">
          Zapisz się
        </a>
        <button v-else
              class="rp-btn rp-btn-secondary rp-cursor-not-allowed"
              disabled>
          Brak miejsc
        </button>
    </div>
  </div>
</template>

<script setup>
defineProps({
  group: {
    type: Object,
    required: true
  }
});
</script>
